<div class="selected-card">
    <div class="contentInner" [ngClass]="type === 'active' ? 'activeContent' : 'pendingContent'">
        <div class="itemText">
            <div class="title">
                {{ appL === 'ar' ? getShortTitle(item.detail?.arabic_title) : getShortTitle(item.detail?.title) }}
            </div>
            <div class="desc">
                <!-- {{item.start_date}} {{" - " | translate}} {{item.end_date}} -->
                {{ appL === 'ar' ? getShortDesc(item.detail?.a_description) : getShortDesc(item.detail?.description) }}
            </div>
            <!-- <div class="planDur">
                {{item.start_date}} {{" - " | translate}} {{item.end_date}}
            
            </div> -->
        </div>
        <!-- <div class="progressDur">
                            <div class="progress" [style.width]="progressVal + '%'"></div>
                    </div> -->

        <div class="footerBlock">

            <div class="typeTag">

                <div class="mealType">
                    <div class="mealText">
                        <div class="mealContainer mealCat">
                            {{"meals" | translate}}

                            &nbsp;
                            <span>
                                {{item?.detail?.total_meals}}
                            </span>

                        </div>

                        <div class="mealContainer snackCat">
                            {{"snacks" | translate}}

                            &nbsp;
                            <span>
                                {{item?.detail?.total_snacks}}
                            </span>
                        </div>
                    </div>

                    <div class="price">
                        <div class="smallP">
                            <ng-container *ngIf="appL === 'ar';else engCurr">
                                <!-- {{storeData.a_currency}} -->
                                {{ storeData.a_currency ? storeData.a_currency : "KWD" | translate }}
                            </ng-container>
                            <ng-template #engCurr>
                                <!-- {{storeData.currency}} -->
                                {{ storeData.currency ? storeData.currency : "KWD" | translate }}
                            </ng-template>
                        </div>
                        {{item.cost | number:'1.3-3'}}
                    </div>
                </div>
                <div class="subDates">
                    {{item.start_date}} {{" - " | translate}} {{item.end_date}}
                    <div class="progressTextI">
                        <div class="progressText">
                            ({{remaining}})</div> {{"of" | translate}} {{item.detail?.day}} {{"days" | translate}}
                    </div>
                </div>
            </div>

            <div class="progressDur">
                <div class="progress" [style.width.%]="progressVal"></div>
                <!-- <div 
        class="progress" 
        [ngStyle]="{ 'width': subscriptionProgress + '%' }">
      </div> -->

            </div>
            <div class="btnBarBottom">

                <div class="mainBtnBottom" (click)="renewClick()" [ngClass]="type === 'active' ? 'renewSub' : 'hideSub'">
                    {{ "renew" | translate }}
                    <ion-icon class="smallIcon" [src]="type === 'active' ? '../../assets/svg/refresh.svg' : '../../assets/svg/refresh.svg'"></ion-icon>
                </div>
                <div class="mainBtnBottom" (click)="handleClick1()" [ngClass]="type === 'active' ? 'freezeSub' : 'cancelSub'">
                    {{ type === 'active' ? "freeze" : "cancel" | translate }}
                    <ion-icon class="smallIcon" [src]="type === 'active' ? '../../assets/svg/pause.svg' : '../../assets/svg/trash.svg'"></ion-icon>
                </div>
                <div class="mainBtnBottom" (click)="handleClick2()" [ngClass]="type === 'active' ? 'upgradeSub' : 'payNowSub'">
                    {{ type === 'active' ? "upgrade" : "pay_now" | translate }}
                    <ion-icon class="smallIcon" [src]="type === 'active' ? '../../assets/svg/upg.svg' : '../../assets/svg/complete.svg'"></ion-icon>
                </div>
            </div>
        </div>

    </div>